import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="date-range"
// Keeps the end date in step with the start date: picking a start date
// fills an empty end date and never lets the end fall before the start.
// The optional daypart field (half day) is only offered for a single day.
export default class extends Controller {
  static targets = ["start", "end", "daypartField", "daypart"]

  connect() {
    this.toggleDaypart()
  }

  syncEnd() {
    const start = this.startTarget.value
    if (!start) return

    this.endTarget.min = start
    if (!this.endTarget.value || this.endTarget.value < start) {
      this.endTarget.value = start
    }
    this.toggleDaypart()
  }

  toggleDaypart() {
    if (!this.hasDaypartFieldTarget) return

    const start = this.startTarget.value
    const singleDay = start !== "" && start === this.endTarget.value
    this.daypartFieldTarget.hidden = !singleDay
    if (!singleDay && this.hasDaypartTarget) this.daypartTarget.value = ""
  }
}
